module.exports = __webpack_public_path__ + "img/point.34540b3e.png";